import React, { useEffect, useState } from "react";
import { cashfreeSandbox } from "cashfree-pg-sdk-javascript";
import { useDispatch, useSelector } from "react-redux";
// NOTE: payment_failure (QueriesSlice' `paymentfailed`) is deliberately NOT
// imported — that endpoint is no longer called from anywhere in the app.
import { verifytransaction } from "../../../store/Queries/QueriesSlice";
import { payment_verification } from "../../../store/BookingIntermediaterypage/airlineairportslice";
import { updateStoredSearch } from "../../../store/Newsearchform/Newsearchform";
import { selectStoredBookingId } from "../../../store/Newslices/bookingIdSlice";

// import{Bookingintermediatrypage} from '../PaymentSection/Bookingintermediatrypage'
import { useNavigate } from "react-router-dom";
import Bookingintermediatrypage from "./BookingIntermediatrypage";
const CashFreePaymentModal = ({
  paymentSessionId,
  orderId,
  bookingType,
  selectedItem,
  setPaymentSessionId,
  setResponseMsg,
  queryDatas,
}) => {
  const ref = React.createRef();
  // console.log(selectedItem,"selectedItem");
  // console.log("queryid",nodeData)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector(updateStoredSearch);
  // const queryiddata=useSelector(updatequeryid);
  const storedBookingId = useSelector(selectStoredBookingId);

// console.log(state?.payload?.newsearchform,state,"hi");
  const { newsearchformdata, rqueryid,bookingid, bookingdata } =
    state?.payload?.newsearchform;
  // console.log(bookingdata, "bookingdatabookingdata");
  console.log(rqueryid,"rqueryid");

  const [orderIds, setOrderIds] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [selectedItem, setSelectedItem] = useState(null);
  // selectedItem.queryId = bookingdata?.queryId || null

  const requestType = newsearchformdata?.requestType ? newsearchformdata?.requestType : "1";
  const value = {
    orderid: orderId,
    requestType,
    ...(requestType === 2 || requestType === "2"
      ? { queryId: rqueryid || queryDatas?.queryId }
      : {}),
  };
  //     const nodedata2={
  //     ...nodeData,
  //     mode:"online",
  // }
  const queryidofflinepayment = {
    paymentmode: "online",
    queryId: rqueryid,
  };
  useEffect(() => {
    // console.log(value, "value", paymentSessionId);
    if (paymentSessionId) {
      //ref.current.innerHTML=""
      let cashfree = new cashfreeSandbox.Cashfree(paymentSessionId);
      let parent = document.getElementById("drop_in_container");
      cashfree.drop(parent, {
        onSuccess: (res) => {
          // console.log(res, "cashfree");
          queryDatas.transactionId = res?.transaction?.transactionId;
          queryDatas.orderId = res?.order?.orderId;
          //   setOrderIds(res?.order?.orderId)
          const verifypayload = {
            bookingData:{...selectedItem,bookingId:storedBookingId,queryId:rqueryid,ratesFrom:selectedItem?.flightItineraries[0]?.rates_from?selectedItem?.flightItineraries[0]?.rates_from:selectedItem?.ratesFrom},
            queryId:rqueryid || null,
            bookingAmount: selectedItem?.rateDetails?.totalAmount, //add in file
            transactionId: res?.transaction?.transactionId, //add in file
            orderId: res?.order?.orderId, //add in file\
                // dynamic this
            
          };
          queryDatas.activePaymentMethod = res?.order?.activePaymentMethod;
          //setTimeout(()=>{
          // console.log("payment verification", value);
          dispatch(payment_verification(value))
            .then((res) => {
              // console.log(res?.statusCode, "res");
              // if(res?.statusCode === 200){
              dispatch(verifytransaction(verifypayload))
                .then((res) => {
                  if (res?.payload?.data?.statusCode === 200) {
                    // setOrderIds(queryDatas.orderId)
                    setResponseMsg(res?.payload?.data);
                    setPaymentSessionId("");
                    setIsModalOpen(true);
                  }
                })
                .catch((err) => {
                  console.error(err);
                });
              // }
            })
            .catch((err) => {
              console.error(err);
            });

          //},3000)
        },
        onFailure: (res) => {
          const msg = {
            message: "Transaction Failed",
            success: "error",
          };
          setPaymentSessionId("");
          setResponseMsg(msg);
        },
        components: ["order-details", "card", "upi", "app", "netbanking"],
        style: {
          theme: "#FCB614",
          color: "#FCB614",
          fontSize: "14",
          backgroundColor: "#ffffff",
        },
      });
    }
  }, [paymentSessionId]);
  return (
    <>
      <div className="py-10" ref={ref} id="drop_in_container"></div>
      {isModalOpen && (
        <Bookingintermediatrypage
          queryidofflinepayment={queryidofflinepayment}
          isOpen={isModalOpen}
          onClose={() => navigate("/search-rates")} //setIsModalOpen(false)&&
          selectedItem={selectedItem}
          // props={props}
          setIsModalOpen={setIsModalOpen}
          // nodeData1={nodedata2}

          title="Booking Confirmation"
          onConfirm={() => navigate("/booking-history")}
        />
      )}
    </>
  );
};

export default CashFreePaymentModal;
